import { selector } from 'lib/selectors';

import { PaymentProviderStatuses } from './helpers';
import { currentCompanyIdSelector } from 'domain/documents';

export const paySettings = (state) => state.paySettings;

export const paymentProvidersSelector = selector(paySettings, (p) => p.providers);

export const firstActivePaymentProviderNameSelector = selector(
  paymentProvidersSelector,
  (p) => p.find((item) => item.status === PaymentProviderStatuses.connected)?.providerName,
);

export const connectedPaymentProviderIdSelector = selector(
  paymentProvidersSelector,
  (p) => p.find((item) => item.status === PaymentProviderStatuses.connected)?.id,
);

export const isConnectedPaymentProviderSelector = selector(paymentProvidersSelector, (p) =>
  p.some((item) => item.status === PaymentProviderStatuses.connected),
);

export const hasConnectedPaymentProviderSelector = selector(
  paymentProvidersSelector,
  (p) => !p.isEmpty() && p.some((provider) => provider.get('status') === PaymentProviderStatuses.connected),
);

export const hasPendingKYCPaymentProviderSelector = selector(
  paymentProvidersSelector,
  (p) => !p.isEmpty() && p.some((provider) => provider.get('status') === PaymentProviderStatuses.kycPending),
);

export const isProvidersLoadedSelector = selector(paySettings, (p) => p.isProvidersLoaded);

export const providerApproversSelector = selector(paySettings, (p) => p.approvers);

export const shouldRenewProviderApprovers = (companyId) =>
  selector(
    providerApproversSelector,
    currentCompanyIdSelector,
    (approvers, currentCompanyId) => !approvers.size || currentCompanyId !== companyId,
  );

export const shouldRenewPaymentProviders = selector(paymentProvidersSelector, (p) => !p.size);
